/**
 * A1 风格坐标工具：列号 ↔ 字母，坐标生成与解析。
 * 列号 1→A, 26→Z, 27→AA, 28→AB ...
 */

/** 列号（从 1 开始）转为字母。 */
export function colToLetters(col: number): string {
  if (col < 1) throw new Error(`列号必须从 1 开始，收到 ${col}`);
  let n = col;
  let s = '';
  while (n > 0) {
    const rem = (n - 1) % 26;
    s = String.fromCharCode(65 + rem) + s;
    n = Math.floor((n - 1) / 26);
  }
  return s;
}

/** 字母列名转为列号。 */
export function lettersToCol(letters: string): number {
  let n = 0;
  for (const ch of letters.toUpperCase()) {
    n = n * 26 + (ch.charCodeAt(0) - 64);
  }
  return n;
}

/** 由 (row, col) 生成单元格坐标名，如 (1,1)→A1, (3,27)→AA3。 */
export function coordName(row: number, col: number): string {
  return `${colToLetters(col)}${row}`;
}

/** 解析坐标名到 (row, col)。 */
export function parseCoord(name: string): { row: number; col: number } {
  const m = /^([A-Z]+)([1-9][0-9]*)$/.exec(name);
  if (!m) throw new Error(`非法单元格坐标：${name}`);
  return { row: Number(m[2]), col: lettersToCol(m[1]!) };
}
